import { render, staticRenderFns } from "./AccessLogDetails.vue?vue&type=template&id=9e2b84a4&scoped=true&"
import script from "./AccessLogDetails.vue?vue&type=script&lang=js&"
export * from "./AccessLogDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccessLogDetails.vue?vue&type=style&index=0&id=9e2b84a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2b84a4",
  null
  
)

/* custom blocks */
import block0 from "./AccessLogDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports